module.exports = __webpack_public_path__ + "img/2025-04-12a_1.4be225da.jpg";